export default {
  left: {
    detection: 'Click for device detection',
    group: 'My group:',
    location: 'Schedule location:',
    description: 'Schedule notes:',
    scoreChart: 'Score sheet:',
    scoreChartDescription: 'Score sheet description',
  },
  logout: 'logout',
  right: {
    title: 'Task List',
    searchPlaceholder: 'name',
  },
  interviewStatus: {
    login: 'Logged in',
    online: 'online',
    offline: 'offline',
  },
  score: 'score',
  average: 'average',
  class: 'class',
  nodata: 'No task',
  401: 'Login expired, please login again',
  status: {
    waiting: 'Not started',
    interviewing: 'In progress',
    complete: 'complete',
    default: 'An error occurred',
  },
  signOut: {
    msg: 'Sure to withdraw from the interview scoring system?',
    cancel: 'Cancel',
  },
};
